import React, {useState} from "react"
import { useNavigate } from "react-router-dom"

import "./Sign.css"
import kakaoIcon from "../../assets/loginKakao.svg"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import {sendRequest, storeData, validateEmail} from "../../common";
import KakaoLogin from "react-kakao-login";

const token = 'c03561d986ff457807d653d3d1d9e536'

function SignIn() {

	const navigate = useNavigate()

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [isExpert, setIsExpert] = useState(true)

	const login = (e) => {
		e.preventDefault()

		sendRequest('accounts/email/login/', 'POST', {
			email,
			password,
		}, data => {
			// console.log(data)
			storeData('accessToken', data?.tokens?.accessToken)
			storeData('user', data?.user)
			alert('로그인 되었습니다. 홈 화면으로 이동합니다.')
			setTimeout(() => navigate('/'), 800)
		}, (data, code) => {
			alert(data?.msg)
		})
	}

	const UseLoginForm = ({render}) => (
		<KakaoLogin
			token={token}
			onSuccess={({response, profile}) => {
				sendRequest('accounts/social/login/', 'POST', {
					snsType: '카카오',
					snsId: profile?.id,
					email: null,
					isExpert
				}, data => {
					storeData('accessToken', data?.tokens?.accessToken)
					storeData('user', data?.user)
					alert('로그인 되었습니다. 홈 화면으로 이동합니다.')
					setTimeout(() => navigate('/'), 800)
				}, (data, code) => {
					console.log(data, code)
				})
			}}
			onFail={console.error}
			onLogout={console.info}
			useLoginForm
			render={render}
		/>
	);

	return (
		<>
			<Nav />
			<SubBanner title={"로그인"} firstText={"인컬리지에서 다양한 서비스를 경험해보세요."} />
			<div className="container">
				<div className="cardContent signCard">
					<section>
						<form className="cardForm" name="signIn">
							{/*<div className="memberWrap">*/}
							{/*	<button*/}
							{/*		className={isExpert ? "active" : null}*/}
							{/*		type="button"*/}
							{/*		onClick={() => setIsExpert(true)}*/}
							{/*	>*/}
							{/*		전문가 회원*/}
							{/*	</button>*/}
							{/*	<button*/}
							{/*		className={!isExpert ? "active" : null}*/}
							{/*		type="button"*/}
							{/*		onClick={() => setIsExpert(false)}*/}
							{/*	>*/}
							{/*		일반 회원*/}
							{/*	</button>*/}
							{/*</div>*/}
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">이메일</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="email" name="emailId" placeholder="이메일을 입력해주세요" required value={email} onChange={e => setEmail(e.target.value)} onBlur={() => validateEmail(email, setEmail)}/>
										</span>
									</div>
								</div>
							</div>
							<div className="formWrap">
								<div className="formItem">
									<div className="formHead">
										<span className="formName">비밀번호</span>
									</div>
								</div>
								<div className="formItem">
									<div className="formBody">
										<span>
											<input type="password" name="password" placeholder="비밀번호를 입력해주세요" required value={password} onChange={e => setPassword(e.target.value)} />
										</span>
									</div>
									<button
										className="btnLink"
										type="button"
										onClick={() => {
											navigate("/reset-password")
										}}>
										비밀번호를 잊으셨나요?
									</button>
								</div>
							</div>
							<div className="buttonWrap">
								<button className="submitBtn" type="submit" onClick={login}>
									로그인
								</button>
								<button
									className="signUpBtn"
									// type="submit"
									onClick={() => {
										navigate("/sign-up")
									}}>
									회원가입
								</button>
							</div>
							<div className="snsWrap">
								<span>소셜 아이디로 간편 로그인</span>
								<UseLoginForm
									render={({onClick}) => (
										<button type="button" className="kakaoBtn" onClick={onClick}>
											<img src={kakaoIcon} alt="카카오 아이콘" /> 카카오 로그인
										</button>
									)}
								/>
							</div>
						</form>
					</section>
				</div>
			</div>
			<Footer />
		</>
	)
}

export default SignIn
